import { render, staticRenderFns } from "./CustomerBirthdayModal.vue?vue&type=template&id=bf373f58&"
import script from "./CustomerBirthdayModal.vue?vue&type=script&lang=js&"
export * from "./CustomerBirthdayModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports